import { useState } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { motion, AnimatePresence } from "framer-motion";
import Sidebar from "@/components/Sidebar";
import TopBar from "@/components/TopBar";
import { ShopProvider, useShop } from "@/contexts/ShopContext";

function LayoutInner() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();
  const { currentShop, shops, setCurrentShopId } = useShop();

  return (
    <div className="app">
      <Sidebar mobileOpen={mobileOpen} onCloseMobile={() => setMobileOpen(false)} />
      <main className="content">
        <TopBar onMenuToggle={() => setMobileOpen(true)} shop={currentShop} />
        <div className="page">
          {shops.length > 1 && (
            <div style={{ marginBottom: 16 }}>
              <select
                className="select"
                value={currentShop?.id || ""}
                onChange={(e) => setCurrentShopId(e.target.value)}
                data-testid="shop-switcher"
              >
                {shops.map((s) => (
                  <option key={s.id} value={s.id}>{s.name}</option>
                ))}
              </select>
            </div>
          )}
          <AnimatePresence mode="wait">
            <motion.div
              key={location.pathname}
              initial={{ opacity: 0, y: 12 }}
              animate={{ opacity: 1, y: 0 }}
              exit={{ opacity: 0, y: -8 }}
              transition={{ duration: 0.25, ease: "easeOut" }}
            >
              <Outlet />
            </motion.div>
          </AnimatePresence>
        </div>
      </main>
    </div>
  );
}

export default function DashboardLayout() {
  return (
    <ShopProvider>
      <LayoutInner />
    </ShopProvider>
  );
}
